import React, {FC} from 'react';
import SharedTransactionTable from '../common/SharedTransactionTable';

const ApprovedTable: FC = () => {
  return <SharedTransactionTable filterStatus='approved' />;
};

export default ApprovedTable;
